// components/StationLegendSection.js
import React from 'react';
import { Typography, Box, Grid, Avatar } from '@mui/material';

function StationLegendSection({ title, items }) {
    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" fontWeight="medium" gutterBottom>
                {title}
            </Typography>
            <Grid container spacing={2}>
                {items.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.name}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {item.image ? (
                                <Box
                                    component="img"
                                    src={item.image}
                                    alt={item.name}
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        mr: 2,
                                        borderRadius: 2,
                                        objectFit: 'contain',
                                        bgcolor: '#f0f0f0',
                                        p: 1,
                                    }}
                                />
                            ) : (
                                <Avatar
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        mr: 2,
                                        bgcolor: item.color || 'primary.main',
                                        fontWeight: 'bold',
                                        fontSize: '1.25rem',
                                    }}
                                    variant="rounded"
                                >
                                    {item.id}
                                </Avatar>
                            )}
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    {item.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.description}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default StationLegendSection;
